import { type ServiceMethod } from '@/application/interfaces/service';

export interface Response {
  email: string;
  phone: string;
  name: string;
  id: string;
  user_url: string;
  cartItems: number | null;
  picture: string | null;
  context: 'ecommerce' | 'assisted-sale' | 'app' | 'app-store';
  region: string;
  regionId: string;
  regionName: string;
  selectedRegionName: string;
  zipCode: string;
  showDisclaimer: boolean;
  regionDriveThru: boolean;
  storeSlug: string | null;
  salesForceId: string | null;
  isLegalUser: boolean;
  isEmployee: boolean;
  locationSource?: 'cloudflare' | 'user' | null;
  companyId: string | null;
  userTrackingId: string;
  loyaltyProgram: {
    active: boolean;
    professional: boolean;
    favoriteStore: string;
  };
}

/**
 * Essa mudança no endpoint é necessária para o correto funcionamento da
 * aplicação no contexto do APP. Localmente, não conseguimos usar a rota web, pois
 * os cookies não são enviados na requisição (por se trar de um dominio diferente).
 */
const endpoint =
  process.env.NODE_ENV === 'development'
    ? '/api/v1/user-resources'
    : '/user-resources';

const getUserResources: ServiceMethod<Response> =
  (httpClient) => async (options) => {
    const { body } = await httpClient.get<Response, undefined, undefined>(
      endpoint,
      options
    );

    return body;
  };

export default getUserResources;
